export default __webpack_public_path__ + "static/media/soal-3-right.ca1f99db.png";